export const sponsors = [
 { name: "Apotheke Ryser AG", img: "/logos/ryser.png", url: "https://apotheke-ryser.ch/" },
 { name: "Bimo-personal AG Burgdorf", img: "/logos/Logo_Bimo.svg", url: "https://www.bimo-personal.ch/kontakt/burgdorf/" },
 { name: "Creafloor GmbH", img: "/logos/creafloor.png", url: "https://creafloor.ch/" },
 { name: "Diacosa AG", img: "/logos/diacosa.png", url: "https://www.diacosa.ch/" },
 { name: "Garage Hofmann AG", img: "/logos/hofmann.svg", url: "https://www.hofmann.swiss/", invert: true },
 { name: "Gschwend Immobilien GmbH", img: "/logos/gschwend.webp", url: "https://gschwend-immobilien.ch/" },
 { name: "Immobi Liegenschaften AG", img: "/logos/immobi.png", url: "https://www.immobi.ch" },
 { name: "Frauenärztin Nina Kaderli", img: "/logos/nina.avif", url: "https://www.frauenaerztin-kaderli.ch/", invert: true },
 { name: "Oesch", img: "/logos/oesch.png", url: "https://www.oesch1898.ch/", invert: true },
 { name: "Buri", img: "/logos/burigartenbau.png", url: "https://www.burigartenbau.ch/" },
];